import classnames from "~utils/classnames/classnames";

import Icon, { IconName } from "~ts_components/Icon/Icon";

export type ButtonColor = "primary" | "secondary" | "black" | "grey";
export type ButtonVariant = "solid" | "outline";
export type ButtonSize = "sm" | "md";

export interface ButtonVisualProps {
  children?: React.ReactNode;
  color?: ButtonColor;
  variant?: ButtonVariant;
  size?: ButtonSize;
  disabled?: boolean;
  startIcon?: IconName;
  startIconClassName?: string;
  endIcon?: IconName;
  endIconClassName?: string;
  className?: string;
}

const VARIANT_CLASSES: {
  [T in ButtonVariant]: Partial<Record<ButtonColor, string>>;
} = {
  solid: {
    primary:
      "bg-brand-secondary text-white hover:bg-brand-secondary-light disabled:bg-primary/50",
    black: "bg-black text-white hover:bg-matte-black disabled:bg-black/50",
  },
  outline: {
    grey: "border-2 border-grey-border text-black hover:border-black disabled:opacity-50",
  },
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
  sm: "px-4 h-11 text-body-bold",
  md: "px-6 h-14 text-body-bold",
};

const PrimaryButtonVisual: React.FC<ButtonVisualProps> = ({
  children,
  color = "black",
  variant = "solid",
  size = "md",
  disabled = false,
  startIcon,
  startIconClassName,
  endIcon,
  endIconClassName,
  className,
}) => {
  return (
    <span
      aria-disabled={disabled}
      className={classnames(
        "inline-flex items-center justify-center gap-2 rounded-full font-bold transition-colors duration-300",
        SIZE_CLASSES[size],
        VARIANT_CLASSES[variant][color],
        disabled && "cursor-not-allowed",
        className,
      )}
    >
      {startIcon && (
        <Icon name={startIcon} iconClassName={startIconClassName} />
      )}
      {children}
      {endIcon && <Icon name={endIcon} iconClassName={endIconClassName} />}
    </span>
  );
};

export default PrimaryButtonVisual;
